// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__6wInB","md":"Card_md__urS9g","sm":"Card_sm__W2I4L","pulse":"Card_pulse__n2nr0"};